'use es6';

import { Record } from 'immutable';
import BrandingRecord from './BrandingRecord';
const PresentationRecord = Record({
  skipForm: null,
  user: {},
  portalId: null,
  name: null,
  sharedWithVid: null,
  hasActivity: null,
  shortLink: null,
  id: null,
  slides: null,
  accessId: null,
  userId: null,
  pdfUrl: null,
  brandingMetadata: null
}, 'PresentationRecord');

PresentationRecord.create = presentation => {
  return new PresentationRecord(Object.assign({}, presentation, {
    brandingMetadata: new BrandingRecord(presentation.brandingMetadata)
  }));
};

PresentationRecord.convertFromDocumentRecord = (documentRecord, pdfUrl, brandingMetadata, userContainer) => {
  const {
    id,
    portalId,
    title,
    slides
  } = documentRecord.toObject();
  const user = userContainer.get();
  return new PresentationRecord({
    id,
    portalId,
    name: title,
    slides: slides.toJS(),
    skipForm: true,
    user: {
      firstName: user.first_name,
      lastName: user.last_name,
      email: user.email
    },
    hasActivity: false,
    pdfUrl,
    brandingMetadata
  });
};

export default PresentationRecord;